// extracted by mini-css-extract-plugin
module.exports = {"greenBorder":"Header_greenBorder__4s8b_","headerText":"Header_headerText__TrDnO"};